import { serviceBase, authorizations } from "../service";

const AddressBook = {
  ...serviceBase,
  resource: "addressbooks",
  resourceRole: "addressbook"
};
AddressBook.authorizations = authorizations(AddressBook);
export default AddressBook;
